/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 09/11/21
 */

import React from 'react';
import { ArrayControlProps, JsonSchema, Paths } from '@jsonforms/core';

export const getValidColumnProps = (scopedSchema: JsonSchema) => {
    if (scopedSchema.type === 'object' && typeof scopedSchema.properties === 'object') {
        return Object.entries(scopedSchema.properties)
            .filter(([, property]) => property.type !== 'array')
            .map(([name]) => name);
    }
    // primitives
    return [''];
};

interface CellProps {
    propName?: string;
    rowPath: string;
    schema: ArrayControlProps['schema'];
    cells?: ArrayControlProps['cells'];
    enabled: ArrayControlProps['enabled'];
}

export const generateCells = (
    Cell: React.ComponentType<CellProps>,
    schema: ArrayControlProps['schema'],
    rowPath: string,
    enabled: ArrayControlProps['enabled'],
    cells: ArrayControlProps['cells'],
) => {
    if (schema.type === 'object') {
        return getValidColumnProps(schema).map((prop) => {
            const cellPath = Paths.compose(rowPath, prop);
            const props = {
                propName: prop,
                schema,
                rowPath,
                enabled,
                cells,
            };
            return <Cell key={cellPath} {...props} />;
        });
    } else {
        // primitives
        const props = {
            schema,
            rowPath,
            enabled,
        };
        return <Cell key={rowPath} {...props} />;
    }
};
